import React from 'react';
import iconNs from '@ant-design/icons';

const Icon = iconNs.default || iconNs;

export function SelectFieldIconComponent() {
  return (
    <svg width="1em" height="1em" viewBox="0 0 1000 1000" style={{ enableBackground: 'new 0 0 1000 1000' }} role="img" >
      <path d="M971.01 288.77H298.94c-15.3 0-27.7-12.4-27.7-27.7s12.4-27.7 27.7-27.7h672.07c15.3 0 27.7 12.4 27.7 27.7s-12.4 27.7-27.7 27.7zm0 257.6H298.94c-15.3 0-27.7-12.4-27.7-27.7 0-15.3 12.4-27.7 27.7-27.7h672.07c15.3 0 27.7 12.4 27.7 27.7 0 15.3-12.4 27.7-27.7 27.7z" style={{ fill: '#666' }} />
      <path style={{ fill: '#f2f2f2' }} d="M40.11 202.37h138.5v138.5H40.11zM23.82 431.68H194.9v171.08H23.82z" />
      <path d="M194.9 619.04H23.82c-8.99 0-16.28-7.29-16.28-16.28V431.68c0-8.99 7.29-16.28 16.28-16.28H194.9c8.99 0 16.28 7.29 16.28 16.28v171.08c0 8.99-7.29 16.28-16.28 16.28zM40.1 586.48h138.52V447.96H40.1v138.52zm930.91 205.76H298.94c-15.3 0-27.7-12.4-27.7-27.7s12.4-27.7 27.7-27.7h672.07c15.3 0 27.7 12.4 27.7 27.7s-12.4 27.7-27.7 27.7z" style={{ fill: '#666' }} />
      <path style={{ fill: '#f2f2f2' }} d="M23.82 677.55H194.9v171.08H23.82z" />
      <path d="M194.9 864.91H23.82c-8.99 0-16.28-7.29-16.28-16.28V677.55c0-8.99 7.29-16.28 16.28-16.28H194.9c8.99 0 16.28 7.29 16.28 16.28v171.08c0 8.99-7.29 16.28-16.28 16.28zM40.1 832.35h138.52V693.83H40.1v138.52zm138.51-555.71v64.22H40.11v-138.5h116.56l28.93-32.58H23.82c-8.99 0-16.29 7.3-16.29 16.29v171.08c0 8.99 7.3 16.29 16.29 16.29H194.9c8.99 0 16.29-7.3 16.29-16.29V239.96l-32.58 36.68z" style={{ fill: '#666' }} />
      <path d="M211.18 218.64v-32.56c0-6.16-3.56-11.33-8.6-14.1l-26.98 30.39h3.01v52.96l32.57-36.69z" style={{ fill: '#666' }} />
      <path d="M229.29 151.37c-5.15 0-10.29 2.12-13.99 6.29L113.46 272.35 86.3 245.18a18.657 18.657 0 0 0-13.23-5.48c-4.79 0-9.57 1.83-13.23 5.48-7.3 7.3-7.3 19.15 0 26.46l41.2 41.19c3.51 3.51 8.28 5.48 13.23 5.48.19 0 .37-.01.56-.01 5.14-.16 10-2.42 13.44-6.27L243.28 182.5c6.84-7.72 6.15-19.55-1.57-26.41a18.641 18.641 0 0 0-12.42-4.72z" style={{ fill: '#666' }} />
    </svg>
  );
}

function SelectFieldIcon() {
  return (
    <Icon component={SelectFieldIconComponent} />
  );
}

export default SelectFieldIcon;
